import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';
import type { NavCollapseState } from './navCollapse';
import NavPanelToggle from './NavPanelToggle';
import { EXPANDED_ONLY, type PanelVariant } from './navRowClass';
import NebariLogoMark from './NebariLogoMark';

interface NavPanelBrandProps {
  variant: PanelVariant;
  onSetCollapse: (next: NavCollapseState) => void;
}

/**
 * The panel's brand header: the mark, the wordmark, and the control that
 * collapses the panel back to icons.
 *
 * Only the labelled band gets a collapse control here — the icon band's
 * expand control sits at the foot of the rail instead, where there is room for
 * it. Between them each breakpoint band has exactly one toggle, whose position
 * already says which direction it goes.
 */
export default function NavPanelBrand({ variant, onSetCollapse }: NavPanelBrandProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];
  return (
    <div className="mb-2 flex h-10 shrink-0 items-center gap-2.5" style={{ color: t.ink }}>
      <NebariLogoMark size={32} />
      <span
        className={`flex-1 truncate text-base font-bold -tracking-[0.2px] ${EXPANDED_ONLY[variant]}`}
      >
        Nebari
      </span>
      <NavPanelToggle expanded onSet={onSetCollapse} className={EXPANDED_ONLY[variant]} />
    </div>
  );
}
